import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BookOpen, Calendar, Shield, Briefcase, Layers,
  FileText, Smartphone, ArrowRight, ChevronRight, ChevronLeft,
  Quote, Folder,Mail,Check
} from 'lucide-react';
import { Link } from "react-router-dom";
import raviImg from '../assets/ravi.jpeg';
import pujaImg from '../assets/puja.jpeg';

// --- Assets Import ---
import banner1 from '../assets/hero1.png';
import banner2 from '../assets/banner2.png';
import kidBg from '../assets/bgcloud.png';
import invest from '../assets/invest.png';
import sip from '../assets/sip.png';
import mobileApp from '../assets/mobileApp.png';
import con1 from '../assets/con1.png';
import testiSideImg from '../assets/testiSideImg.png';
import contactImg from '../assets/callus.png';
import faqBg from '../assets/faq.png';
// --- Icons Import ---
import sipIcon from '../assets/sip1.png';
import eduIcon from '../assets/education.png';
import marriageIcon from '../assets/marrige.png';
import retirementIcon from '../assets/retire.png';
import loanIcon from '../assets/loan emi.png';
import stepUpIcon from '../assets/sip step up.png';
import delayIcon from '../assets/sip delay.png';
import lumpIcon from '../assets/lumpsum.png';
import fdImg from '../assets/FD.png';
import realEstateImg from '../assets/Real estate.png';
import bondImg from '../assets/bond.png';
import equityImg from '../assets/Equity.png';
import goldImg from '../assets/Gold.png';
import DrawImg from '../assets/Draw1.png';

// --- Blog Images ---
import blog1 from '../assets/blog1.png';
import blog2 from '../assets/blog2.png';
import blog3 from '../assets/blog3.png';
import blog4 from '../assets/blog4.png';
// Helper function to create URL-friendly IDs
//const slugify = (text: string) => 
 // text.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');

// --- Static Data Configuration ---




const comparisonData = [
  { label: "FD", rate: 7, image: fdImg, gradient: "from-blue-400 to-blue-600", text: "text-slate-600" },
  { label: "Bonds", rate: 8, image: bondImg, gradient: "from-green-400 to-emerald-600", text: "text-slate-600" },
  { label: "Real Estate", rate: 10, image: realEstateImg, gradient: "from-slate-400 to-slate-600", text: "text-slate-600" },
  { label: "Gold", rate: 11, image: goldImg, gradient: "from-amber-400 to-yellow-600", text: "text-slate-600" },
  { label: "Equity", rate: 15, image: equityImg, gradient: "from-orange-400 to-red-600", text: "text-slate-600", highlight: true }
];

const offerings = [
  { title: 'PMS / AIF', link: '/pms--aif', desc: 'Access Curated Portfolios from top Fund Managers', icon: <Layers size={28} className="text-white" />, fullColor: "bg-purple-600" },
  { title: 'Mutual Fund', link: '/mutual-funds', desc: 'Choose and Invest Through Leading Funds', icon: <Briefcase size={28} className="text-white" />, fullColor: "bg-blue-600" },
  { title: 'Bond / Corporate FD', link: '/bonds', desc: 'Invest in High-Quality Products', icon: <FileText size={28} className="text-white" />, fullColor: "bg-emerald-600" },
  { title: 'Structured Products', link: '/structured-products', desc: 'Facilitated Access to Market-Linked Solutions', icon: <Smartphone size={28} className="text-white" />, fullColor: "bg-orange-600" },
  { title: 'Legacy & Estate Planning', link: '/legacy--estate-planning', desc: 'Curated Solutions for Wealth Transfer', icon: <BookOpen size={28} className="text-white" />, fullColor: "bg-pink-600" },
  { title: 'Insurance', link: '/insurance', desc: 'Access Life, Health, and Asset Coverage', icon: <Shield size={28} className="text-white" />, fullColor: "bg-slate-700" },
];

const calculators = [
  { title: "Lumpsum", path: "/calculator", image: lumpIcon },
  { title: "SIP", path: "/calculator", image: sipIcon },
  { title: "SIP Step Up", path: "/calculator", image: stepUpIcon },
  { title: "SIP Delay", path: "/calculator", image: delayIcon },
  { title: "Retirement", path: "/calculator", image: retirementIcon },
  { title: "Marriage", path: "/calculator", image: marriageIcon },
  { title: "Education", path: "/calculator", image: eduIcon },
  { title: "EMI / Loan", path: "/calculator", image: loanIcon }
];

const videos = [
  { id: "JGNfq2gg-vo", title: "DreamLadder Capital - Why Should You Invest Through Us" },
  { id: "nuj8ZoFbGEM", title: "DreamLadder Equity Market View" },
  { id: "xEqbYSU3F_I", title: "DreamLadder Equity Market View: Oct 2024" },
  { id: "22glfK-1098", title: "DreamLadder Equity Market View: Oct 2024 (Duplicate)" },
];

const blogs = [
  { id: 1, title: "Are you confused about owning Large Cap or Mid/Small Cap...", date: "July 5, 2022", image: blog1, category: "Mutual Funds" },
  { id: 2, title: "Mutual Funds: Foundations of smart investing", date: "April 27, 2022", image: blog2, category: "Mutual Funds" },
  { id: 3, title: "Power of Compounding: 8th Wonder of the world", date: "March 4, 2022", image: blog3, category: "Mutual Funds" },
  { id: 4, title: "Will & Estate Planning: The Foundation of Legacy", date: "March 4, 2022", image: blog4, category: "Mutual Funds" },
];

const testimonials = [
  { id: 1, text: "Associated with DreamLadder Capital since inception, I value their disciplined asset allocation, consistent reviews, and transparent communication that bring clarity and confidence to my investments.", name: "Puja Rai", title: "CXO & Author | Mumbai", image: pujaImg, link: "#" },
  { id: 2, text: "What I appreciate most is their focus on long-term wealth creation rather than short-term noise. The team ensures my portfolio remains aligned with my financial goals and life stage.", name: "Ravi Shekhar", title: "Radiologist & HOD | NCR", image: raviImg, link: "#" },
 
];

const faqTopics = [
  { label: "Our Company", id: "our-company" },
  { label: "Equity", id: "equity" },
  { label: "Investment", id: "investment-overview" },
  { label: "Mutual Funds", id: "mutual-funds" },
  { label: "Insurance", id: "insurance" },
  { label: "Structured Products", id: "structured-products" },
  { label: "PMS/AIF", id: "pms-aif" },
  { label: "Legacy Planning", id: "legacy-planning" },
  { label: "Payment Related", id: "payment-related" },
  { label: "Account Creation", id: "account-creation" },
  { label: "NRI/OCI", id: "nri-oci" },
  { label: "Indians in US/Canada", id: "indians-us-canada" },
  { label: "Regulations & Compliance", id: "regulations-compliance" },
  { label: "Taxation & Returns", id: "taxation-returns" },
  { label: "Digital Security / Cyber Safety", id: "digital-security-cyber-safety" },
  { label: "Customer Support", id: "customer-support" },
];



const slides = [
  {
    id: 1,
    image: banner1,
    tagline: "Building Wealth, \nPreserving Legacies",
    buttons: true,
    showStats: false,
    isAppSlide: false
  },
  {
    id: 2,
    image: banner2,
    tagline: "Smarter Investing - \nright in your pocket.",
    subtext: "Download the App Now!",
    buttons: false,
    showStats: true,
    isAppSlide: true
  }
];

const extendedSlides = [
  { ...slides[slides.length - 1], id: 'clone-last' },
  ...slides,
  { ...slides[0], id: 'clone-first' }
];

// --- Main Component ---

const Home = () => {
  const navigate = useNavigate();

  // State Management
  const [currentSlide, setCurrentSlide] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [investmentType, setInvestmentType] = useState<'sip' | 'lumpsum'>('sip');
  const [investmentAmount, setInvestmentAmount] = useState(33000);

  const handleNextSlide = useCallback(() => {
  if (isTransitioning) return;
  setIsTransitioning(true);
  setCurrentSlide((prev) => prev + 1);
}, [isTransitioning]);
  useEffect(() => {
  const timer = setInterval(handleNextSlide, 5000);
  return () => clearInterval(timer);
}, [handleNextSlide]);


  useEffect(() => {
    if (!isTransitioning) return;
    const timeout = setTimeout(() => {
      setIsTransitioning(false);
      if (currentSlide === 0) setCurrentSlide(extendedSlides.length - 2);
      else if (currentSlide === extendedSlides.length - 1) setCurrentSlide(1);
    }, 700);
    return () => clearTimeout(timeout);
  }, [currentSlide, isTransitioning]);

 useEffect(() => {
  if (isPaused) return;

  const interval = setInterval(() => {
    setCurrentTestimonialIndex((prev) => (prev + 1) % testimonials.length);
  }, 7000); // ⏱️ increased time (7 seconds)

  return () => clearInterval(interval);
}, [isPaused]);


  useEffect(() => {
    // Jab bhi investment type change ho, default value set karein
    if (investmentType === 'sip') {
      setInvestmentAmount(50000);   // SIP Default: 50k
    } else {
      setInvestmentAmount(1000000); // One-time Default: 10 Lakh
    }
  }, [investmentType]);




  const handlePrevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => prev - 1);
  };

  const handleInvestmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let rawValue = e.target.value.replace(/,/g, '');
    let value = Number(rawValue);

    if (isNaN(value)) value = 0;

    const limit = investmentType === 'sip' ? 500000 : 10000000;
    if (value > limit) value = limit;

    setInvestmentAmount(value);
  };


  const calculateSipValue = (
  monthlyInvestment: number,
  annualReturn: number,
  years: number
) => {
  let value = 0;
  const monthlyRate = annualReturn / 12 / 100;
  const months = years * 12;

  for (let m = 1; m <= months; m++) {
    // SIP invested at beginning of month
    value += monthlyInvestment;

    // then it grows
    value = value * (1 + monthlyRate);
  }

  return value;
};

  const calculateReturns = (rate: number) => {
  const years = 25;
  let finalAmount = 0;

  if (investmentType === 'sip') {
    finalAmount = calculateSipValue(
      investmentAmount,
      rate,
      years
    );
  } else {
    // ✅ Lumpsum is already correct – DO NOT CHANGE
    finalAmount =
      investmentAmount *
      Math.pow(1 + rate / 100, years);
  }

  return (finalAmount / 10000000).toFixed(2); // Cr
};


  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans">
      <style>{`
        input[type=number]::-webkit-inner-spin-button, 
        input[type=number]::-webkit-outer-spin-button { 
          -webkit-appearance: none; 
          margin: 0; 
        }
      `}</style>

      {/* Hero Section */}
      <section className="relative h-[230px] md:h-screen md:min-h-[700px] bg-white overflow-hidden group">
        <button onClick={handlePrevSlide} className="absolute left-1 md:left-4 top-1/2 -translate-y-1/2 z-30 p-1 md:p-2 rounded-full bg-slate-800 text-white hover:bg-red-600 transition-all duration-300 shadow-lg hover:scale-110 opacity-70 hover:opacity-100">
          <ChevronLeft className="w-4 h-4 md:w-6 md:h-6" />
        </button>

        <button onClick={handleNextSlide} className="absolute right-1 md:right-4 top-1/2 -translate-y-1/2 z-30 p-1 md:p-2 rounded-full bg-slate-800 text-white hover:bg-red-600 transition-all duration-300 shadow-lg hover:scale-110 opacity-70 hover:opacity-100">
          <ChevronRight className="w-4 h-4 md:w-6 md:h-6" />
        </button>

        <div className={`flex h-full ${isTransitioning ? 'transition-transform duration-700 ease-in-out' : ''}`} style={{ transform: `translate3d(-${currentSlide * 100}%, 0, 0)` }}>
          {extendedSlides.map((slide, index) => (
            <div key={`${slide.id}-${index}`} className="min-w-full h-full relative flex-shrink-0">
              <div className="absolute inset-0">
               <img
  src={slide.image}
  alt="Hero"
  className="w-full h-full object-cover transform-gpu"
  style={{ backfaceVisibility: 'hidden' }}
/>

              </div>


              {slide.isAppSlide ? (
                // UPDATE: Flex-row on mobile (Side by Side)
                <div className="relative z-10 h-full flex flex-row items-center justify-between px-2 sm:px-12 lg:px-24 max-w-7xl mx-auto">
                  {/* Left Side (Text) - Mobile width 55% */}
                  {/* UPDATE: pt-6 on text to push it down from header */}
                  <div className="flex flex-col items-start text-left w-[55%] md:w-1/2 pt-6 md:pt-8 pl-1 md:pl-0">
                 {/*    <h2 className="font-syne text-[14px] md:text-[38px] font-medium text-black mb-1 md:mb-3 leading-tight whitespace-pre-line tracking-tight">
                      {slide.tagline}
                    </h2> */}
                  <h2 className="font-syne text-2xl md:text-4xl font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">
  {slide.tagline}
</h2>
                    <p className="font-syne text-[10px] md:text-[20px] text-slate-900 mb-1 md:mb-6 font-medium">
                      {slide.subtext}
                    </p>
                    <div className="flex gap-1 md:gap-2 mb-2 md:mb-8">
                      <a href="https://play.google.com/store/search?q=dreamladder+capital&c=apps&hl=en_IN" target="_blank" rel="noreferrer" className="hover:scale-105 transition-transform duration-300">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" className="h-5 md:h-10" />
                      </a>
                      <a href="https://apps.apple.com/in/app/dreamladder-capital/id1527793478" target="_blank" rel="noreferrer" className="hover:scale-105 transition-transform duration-300">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" className="h-5 md:h-10" />
                      </a>
                    </div>

                    <div className="w-full max-w-md border md:border-2 border-red-600 rounded-md md:rounded-xl p-1 md:p-2 bg-white/40 shadow-sm mt-1 md:mt-16">
                      <div className="grid grid-cols-3 gap-0.5 md:gap-2 text-center divide-x md:divide-x-2 divide-red-800/20">
                        <div className="flex flex-col items-center justify-center">
                          <div className="text-[10px] md:text-[24px] font-medium text-slate-900 leading-none mb-0 md:mb-1" style={{ textShadow: '0px 0px 10px rgba(255, 255, 255, 1), 2px 2px 0px rgba(255, 255, 255, 0.8)' }}>
                            500+
                          </div>
                          <div className="text-[8px] md:text-[24px] text-slate-900 font-medium leading-tight">
                            Families
                          </div>
                        </div>

                        <div className="flex flex-col items-center justify-center">
                          <div className="text-[10px] md:text-[24px] font-medium text-slate-900 leading-none mb-0 md:mb-1" style={{ textShadow: '0px 0px 10px rgba(255, 255, 255, 1), 2px 2px 0px rgba(255, 255, 255, 0.8)' }}>
                            12+
                          </div>
                          <div className="text-[8px] md:text-[24px] text-slate-900 font-medium leading-tight">
                            Countries
                          </div>
                        </div>

                        <div className="flex flex-col items-center justify-center">
                          <div className="text-[10px] md:text-[24px] font-medium text-slate-900 leading-none mb-0 md:mb-1" style={{ textShadow: '0px 0px 10px rgba(255, 255, 255, 1), 2px 2px 0px rgba(255, 255, 255, 0.8)' }}>
                            25+
                          </div>
                          <div className="text-[8px] md:text-[24px] text-slate-900 font-medium leading-tight">
                            Experience
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  {/* Mobile App Image Section - Forced Visibility */}
                  {/* UPDATE: Added pt-10 to push image down from header, reset with md:pt-0 */}
                  <div className="flex w-[45%] md:w-1/2 justify-end items-center h-full relative pointer-events-none pt-10 md:pt-0 pb-0 md:pb-8 lg:pb-12 lg:-mr-4">
                    <img
                      src={mobileApp}
                      alt="DreamLadder Mobile App"
                      // UPDATE: Adjusted max-h to 180px to accommodate the padding
                      className="max-h-[180px] md:max-h-[500px] w-auto object-contain animate-in slide-in-from-right duration-1000"
                    />
                  </div>

                </div>
              ) : (
                <>
        {/* DrawImg Overlay - Positioned behind text but on top of background */}
        <div className="absolute inset-0 flex items-center justify-end pr-10 md:pr-20 pointer-events-none z-0">
          <img 
            src={DrawImg}
            alt="Wealth Illustration" 
            className="max-w-[58%] h-auto object-contain opacity-90" 
          />
        </div>
                <div className="relative z-10 h-full flex flex-col justify-center items-start text-left px-4 sm:px-12 lg:px-24 max-w-7xl mx-auto mt-0 md:mt-[-50px]">
                  <div className="flex flex-col items-start text-left">
                    <h2 className="font-syne text-2xl md:text-4xl font-thin text-black/70 text-black mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">
  {slide.tagline}
</h2>

                    <p className="font-syne text-[11px] md:text-[24px] text-slate-900 mb-2 md:mb-8 font-medium max-w-[90%] md:max-w-2xl drop-shadow-md">
                      {slide.subtext}
                    </p>
                    {slide.buttons && (
                      <div className="flex flex-row gap-2 md:gap-4">
                        <a href="/blogs" className="flex items-center px-3 py-1 md:px-4 bg-red-600 border-2 border-red-600 text-white rounded-full hover:bg-[#434242]  hover:border-[#434242] transition duration-300 font-medium text-[10px] md:text-[16px] shadow-xl shadow-red-900/20">
                          <BookOpen size={12} className="mr-1 md:mr-2 md:w-[18px] md:h-[18px]" /> Learning
                        </a>
                        <a href="https://calendly.com/dreamladdercapital/portfolio-discussion-meeting" target="_blank" rel="noreferrer" className="flex items-center px-3 py-1 md:px-4 bg-red-600 border-2 border-red-600 text-white rounded-full hover:bg-[#434242]  hover:border-[#434242] transition duration-300 font-medium text-[10px] md:text-[16px] shadow-xl shadow-red-900/20">
                          <Calendar size={12} className="mr-1 md:mr-2 md:w-[18px] md:h-[18px]" /> Book my appointment
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                </>
              )}
              
            </div>
          ))}
        </div>
      </section>

      {/* Offerings Section */}
      <section className="pt-2 md:pt-4 pb-16 overflow-hidden" id="offerings">
        <div className="max-w-7xl mx-auto px-2 md:px-6 sm:px-12 lg:px-24">
          <div className="flex flex-col lg:flex-row gap-4 md:gap-12 lg:gap-8 items-start">
            
            {/* Left Side: Intro Text & Image */}
            <div className="w-full lg:w-[40%] flex flex-col items-start justify-center lg:h-[550px] lg:pr-10 space-y-2 md:space-y-4 ml-4">
              <h3 className="text-[24px] md:text-[40px] text-slate-900 tracking-tight font-[450]">What we offer</h3>

              <div className="w-full max-w-[200px] md:max-w-[550px] -ml-2">
                <img src={con1} alt="Invest with insight" className="w-full h-auto object-contain opacity-90" />
              </div>

              <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                Your legacy deserves a solid foundation. DreamLadder Capital helps you build lasting wealth through smart, diversified strategies.
              </p>

              <a href="tel:+918908082222" className="mt-2 md:mt-3 block transition-transform duration-300 hover:scale-105 cursor-pointer">
                <img src={contactImg} alt="Call Us" className="h-14 md:h-20 w-auto object-contain drop-shadow-md" />
              </a>
            </div>

            {/* Right Side: Tiles & Ladder - SIDE BY SIDE WITH MATCHING HEIGHT */}
            <div className="w-full lg:w-[60%] flex flex-row items-stretch mt-4 lg:mt-0 lg:justify-end gap-1 md:gap-6 lg:gap-4">
              
              {/* Tiles List */}
             <div className="flex flex-col gap-2 md:gap-4 justify-center z-10 py-2 md:py-3 h-auto w-[80%] md:w-[85%] lg:w-[75%] max-w-[600px] mx-auto mr-8">

                {offerings.map((offer, idx) => (
                  <div key={idx} className="relative group w-full">
                    <a
                      href={offer.link}
                      className="block bg-gray-100 border border-gray-200 rounded-lg md:rounded-2xl py-1 px-1.5 md:py-3 md:px-5 shadow-sm hover:border-grey-600 hover:-translate-x-1 transition-all duration-300 text-center cursor-pointer min-h-[45px] md:min-h-[75px] flex flex-col justify-center z-20 relative group-hover:shadow-grey-900/10"
                      style={{ backgroundImage: `url(${kidBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                    >
                      <h3 className="font-syne text-[10px] md:text-[20px] font-medium text-slate-900 group-hover:text-red-600 mb-0 md:mb-0.5 transition-colors leading-tight">
                        {offer.title}
                      </h3>
                      <p className="text-slate-500 md:text-slate-500  font-medium w-full mx-auto leading-tight transition-colors whitespace-nowrap overflow-hidden text-ellipsis px-1">
                        {offer.desc}
                      </p> 
                    </a>
                  </div>
                ))}
              </div>

              {/* Ladder Image Container 
              <div className="relative w-[35%] md:w-auto md:static flex-shrink-0">
                <img 
                  src={ladder} 
                  alt="Growth Ladder" 
                  className="absolute bottom-0 right-0 h-full w-full object-contain object-bottom md:static md:h-[650px] md:w-auto drop-shadow-lg" 
                />
              </div>
              */}
            </div>
          </div>
        </div>
      </section>

      {/* App & SIP Features */}
      <section className="py-1 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 md:px-6 sm:px-12 lg:px-24">

          {/* Feature 1 */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 lg:gap-12 mb-6 md:mb-0">
            <div className="flex-1 w-full flex justify-center md:justify-start">
              <img
                src={invest}
                alt="Family Dashboard Interface"
                className="h-[200px] md:h-[380px] w-auto object-contain transition-transform duration-500 hover:scale-105"
              />
            </div>
            <div className="flex-1 w-full text-center md:text-left">
              <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 mb-2 tracking-tight"> 
                All Your Family Investments, <br /> One Simple App
              </h3>
              
              <p className="text-slate-600 text-lg md:text-xl leading-relaxed mb-5"> 
                Easily view portfolio performance, transactions, and reports for every family member — anytime, anywhere.
              </p>
              <a
  href="https://dreamladdercapital.my-portfolio.co.in/app/#/login"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block px-4 py-1 bg-red-600 text-white rounded-full font-medium text-[16px] md:text-[18px] hover:bg-[#434242] hover:shadow-red-600/40 transition-all"
>
  Start Now
</a>

            </div>
          </div>

          {/* Feature 2 */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 lg:gap-12 mt-6 md:mt-0">
            <div className="flex-1 w-full text-center md:text-left order-2 md:order-1">
              <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 mb-2 tracking-tight"> 
                Setup SIP in 2 Minutes
              </h3>
              <p className="text-slate-600 text-lg md:text-xl leading-relaxed mb-5"> 
                Setup SIP in Mutual funds and diversify your portfolio to grow your net worth.
              </p>
              <div className="flex flex-row gap-4 justify-center md:justify-start">
                <a
  href="https://dreamladdercapital.my-portfolio.co.in/app/#/login"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block px-4 py-1 bg-red-600 text-white rounded-full font-medium text-[16px] md:text-[18px] hover:bg-[#434242] transition-all"
>
  Setup SIP
</a>
                <button onClick={() => navigate('/calculator')} className="px-4 py-1 bg-red-600 text-white rounded-full font-medium text-[16px] md:text-[18px]  hover:bg-[#434242]  transition-all transform ">
                  SIP Calculator
                </button>
              </div>
            </div>
            <div className="flex-1 w-full flex justify-center md:justify-end order-1 md:order-2">
              <img
                src={sip}
                alt="SIP Interface"
                className="h-[200px] md:h-[380px] w-auto object-contain transition-transform duration-500 hover:scale-105"
              />
            </div>
          </div>

        </div>
      </section>

      {/* Compounding Calculator Section */}
      <section className="py-6 md:py-12 relative overflow-hidden" style={{ backgroundImage: `url(${kidBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-12 lg:px-24 text-center relative z-10">
       {/*   <h3 className="font-syne text-[24px] md:text-[40px] font-medium text-slate-900 mb-1 tracking-tight drop-shadow-[0_2px_2px_rgba(255,255,255,0.8)]">
            Time Reveals the True Wealth Builder
          </h3> 
           <h2 className="font-syne text-2xl md:text-4xl font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Time Reveals the True Wealth Builder</h2> */}
            <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Time Reveals the True Wealth Builder</h2>

          <p className="font-syne text-[16px] md:text-[20px] text-slate-900 font-medium mb-6 drop-shadow-[0_1px_1px_rgba(255,255,255,0.8)]">
            Compounding power over 25 years
          </p>

          <div className="max-w-3xl mx-auto mb-6 bg-white/90 p-4 rounded-2xl shadow-xl backdrop-blur-sm">
            <div className="flex justify-center mb-4">
              <div className="bg-gray-50 p-0.5 rounded-full shadow-sm border border-gray-200 inline-flex">
                <button onClick={() => setInvestmentType('sip')} className={`px-4 py-1 rounded-full text-[14px] md:text-[16px] font-bold transition-all ${investmentType === 'sip' ? 'bg-red-600 text-white shadow-md' : 'text-gray-500 hover:text-gray-900'}`}>Monthly (SIP)</button>
                <button onClick={() => setInvestmentType('lumpsum')} className={`px-4 py-1 rounded-full text-[14px] md:text-[16px] font-bold transition-all ${investmentType === 'lumpsum' ? 'bg-red-600 text-white shadow-md' : 'text-gray-500 hover:text-gray-900'}`}>One-time</button>
              </div>
            </div>

            <div className="relative flex items-center justify-center mb-3">
              <span className="absolute left-1/2 -translate-x-[60px] text-red-800 font-bold z-10 text-lg pointer-events-none">₹</span>
              <input
                type="text"
                value={investmentAmount.toLocaleString('en-IN')}
                onChange={handleInvestmentChange}
                className="w-40 bg-white border-2 border-red-600 text-red-700 text-xl font-bold py-1.5 px-4 rounded-lg text-center focus:outline-none focus:ring-4 focus:ring-red-100 transition-shadow"
              />
            </div>

            <div className="relative w-full h-3 bg-gray-200 rounded-full cursor-pointer mt-2">
              <input type="range" min="500" max={investmentType === 'sip' ? 500000 : 10000000} step="500" value={investmentAmount} onChange={handleInvestmentChange} className="w-full h-full appearance-none bg-transparent absolute top-0 left-0 z-20 cursor-pointer opacity-0" />
              <div className="absolute top-0 left-0 h-full bg-red-600 rounded-full z-10 shadow-sm" style={{ width: `${(investmentAmount / (investmentType === 'sip' ? 500000 : 10000000)) * 100}%` }}></div>
              <div className="absolute top-1/2 -translate-y-1/2 w-6 h-6 bg-white border-4 border-red-600 rounded-full shadow-md z-10 pointer-events-none transition-all" style={{ left: `calc(${(investmentAmount / (investmentType === 'sip' ? 500000 : 10000000)) * 100}% - 12px)` }}></div>
            </div>
            <div className="flex justify-between text-xs text-gray-500 mt-2 font-bold uppercase">
              <span>₹500</span>
              <span>₹{investmentType === 'sip' ? '5 Lakh' : '1 Cr'}</span>
            </div>
          </div>
          <h3 className="font-Genos, sans-serif text-[18px] md:text-[20px] font-medium text-slate-900 mb-6 tracking-widest drop-shadow-[0_2px_2px_rgba(255,255,255,0.8)]">
            After 25 years, it would have accumulated to
          </h3>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6">
            {comparisonData.map((item, idx) => (
              <div key={idx} className="flex flex-col items-center group relative">
                <div className="relative w-28 h-28 md:w-48 md:h-48 rounded-full bg-white border border-gray-200 shadow-[0_15px_40px_-5px_rgba(0,0,0,0.4)] transition-all duration-300 group-hover:scale-105 z-10">
                  <div className="w-full h-full rounded-full bg-white p-[3px]">
                    <div className="w-full h-full rounded-full bg-slate-50 flex flex-col items-center justify-evenly py-2 md:py-3 shadow-inner">
                      <div className="flex flex-col items-center leading-none mt-1">
                        <span className={`text-[16px] md:text-[26px] font-bold tracking-tight ${item.text}`}>
                          ₹{calculateReturns(item.rate)}
                        </span>
                        <span className={`text-[10px] md:text-sm font-bold uppercase mt-0.5 ${item.text}`}>
                          Cr
                        </span>
                      </div>
                      <div className="relative w-16 h-16 md:w-32 md:h-32 flex items-center justify-center -my-3">
                        <img
                          src={item.image}
                          alt={item.label}
                          className={`w-full h-full object-contain drop-shadow-sm transition-transform duration-300 group-hover:scale-110 ${item.label === 'FD' ? '-translate-x-1' : ''}`}
                        />
                      </div>
                      <span className={`text-[12px] md:text-[20px] font-medium tracking-widest text-slate-400 mb-1`}>
                        {item.label}
                      </span>
                    </div>
                  </div>
                </div>
                <div className={`-mt-3 text-[12px] md:text-[18px] font-medium px-3 md:px-4 py-1 md:py-1.5 rounded-full border shadow-md z-20 bg-white text-slate-600 border-gray-100 group-hover:translate-y-1 transition-transform`}>
                  @{item.rate}% Return
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Financial Calculators */}
      <section className="py-6 md:py-16" style={{ backgroundImage: `url(${kidBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
          <div className="text-center mb-8 md:mb-12">
           
              <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Calculators</h2>

          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 max-w-7xl mx-auto">
            {calculators.map((calc, idx) => (
              <div key={idx} onClick={() => navigate(calc.path)} className="group cursor-pointer relative overflow-hidden rounded-2xl md:rounded-3xl shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 aspect-[5/4]">
                <div className="absolute inset-0 bg-white transition-transform duration-700" />
                <div className="relative z-10 w-full h-full flex flex-col items-center justify-center p-2 md:p-4">
                  <img
                    src={calc.image}
                    alt={calc.title}
                    className={`${calc.title === 'SIP' ? 'w-24 h-24 md:w-56 md:h-56' : 'w-20 h-20 md:w-44 md:h-44'} object-contain mb-2 md:mb-4 drop-shadow-md group-hover:scale-110 transition-transform duration-300`}
                  />
                  <h3 className="text-[14px] md:text-[26px] font-medium text-slate-900 tracking-wider text-center drop-shadow-sm px-2">
                    {calc.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Insights */}
      <section className="py-6 relative overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
          <div className="text-center mb-6">
          {/*  <h3 className="text-[28px] md:text-[40px] font-medium text-gray-900 tracking-widest mb-1">Latest Insights</h3> */}
              <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight">Latest Insights</h3>
            <p className="text-[14px] md:text-[18px] text-gray-600 mt-1 font-medium">Market perspective and Financial wisdom to keep you ahead.</p>
          </div>
          <div className="mb-6">
            <h3 className="text-lg font-medium text-slate-800 mb-3 flex items-center gap-2">
              <span className="w-1.5 h-5 bg-red-600 rounded-full"></span>
              Featured Videos
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {videos.map((video, idx) => (
                <div key={idx} className="relative rounded-xl overflow-hidden shadow-md border border-gray-200 bg-black aspect-video group hover:scale-[1.02] transition-transform duration-300">
                  <iframe
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${video.id}?mute=1&loop=1&playlist=${video.id}&rel=0`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h3 className="text-lg font-medium text-slate-800 mb-3 flex items-center gap-2">
              <span className="w-1.5 h-5 bg-red-600 rounded-full"></span>
              Latest Blogs
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {blogs.map((blog) => (
                <div key={blog.id} className="bg-white/90 backdrop-blur-sm rounded-xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow duration-300 border border-gray-100 group cursor-pointer flex flex-col h-full">
                  <div className="h-32 overflow-hidden relative">
                    <img src={blog.image} alt={blog.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                  </div>
                  <div className="p-4 flex flex-col flex-1">
                    <div className="flex items-center text-[12px] text-gray-500 mb-2 space-x-3 font-normal tracking-wide">
                      <span className="flex items-center">
                        <Calendar size={14} className="mr-1 text-red-500" /> {blog.date}
                      </span>
                      <span className="flex items-center">
                        <Folder size={14} className="mr-1 text-red-500" /> {blog.category}
                      </span>
                    </div>
                    <h4 className="font-normal text-slate-800 text-[18px] leading-tight group-hover:text-red-600 transition-colors line-clamp-2">
                      {blog.title}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      {/*
      <section className="py-6 md:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6 sm:px-12 lg:px-24">
          <div className="text-center mb-6 md:mb-10">
          
            <h3 className="text-[24px] md:text-[40px] text-slate-900 tracking-tight font-medium">What clients say about us</h3>
        
          </div>

          <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-16">
            
          
            <div className="w-full lg:w-[35%] flex justify-center lg:justify-end mb-4 lg:mb-0">
              <img src={testiSideImg} alt="Happy Clients" className="w-[200px] lg:w-full max-w-[380px] object-contain drop-shadow-lg" />
            </div>

            <div className="w-full lg:w-[65%] relative">
              <div className="overflow-hidden">
                <div className="flex transition-transform duration-700 ease-in-out" style={{ transform: `translateX(-${currentTestimonialIndex * 100}%)` }}>
                  {testimonials.map((item) => (
                    <div key={item.id} className="w-full flex-shrink-0 px-2">
                      
                      <div className="bg-white border border-gray-200 shadow-xl rounded-lg overflow-hidden p-6 md:p-10">
                        <div className="flex flex-col md:flex-row gap-8 items-start justify-between">
                          <div className="flex-shrink-0 hidden md:block">
                            <Quote className="w-12 h-12 text-purple-700 fill-current opacity-90" />
                          </div>
                          <div className="flex-grow pt-1 max-w-2xl">
                            <Quote className="w-8 h-8 md:w-10 md:h-10 text-purple-700 fill-current opacity-90 mb-2 md:mb-4 md:hidden" />
                            <p className="text-[14px] md:text-[18px] text-slate-700 font-medium leading-relaxed mb-4 md:mb-6">"{item.text}"</p>
                            <div>
                              <h4 className="font-bold text-slate-900 text-[18px] md:text-[22px]">{item.name}</h4>
                              <p className="font-medium text-[14px] md:text-[18px] text-slate-500 mt-1">{item.title}</p>
                            </div>
                          </div>
                          <div className="flex-shrink-0 flex flex-col items-center md:items-start w-full md:w-auto mt-4 md:mt-0 border-t md:border-t-0 border-gray-100 pt-4 md:pt-0">
                            <img src={item.image} alt={item.name} className="w-16 h-16 md:w-28 md:h-28 object-cover rounded-md shadow-md mb-2 md:mb-4" />
                            <a href={item.link} className="inline-flex items-center text-blue-600 hover:text-blue-800 font-bold text-sm md:text-base group">
                              Meet {item.name.split(' ')[0]} <ArrowRight size={18} className="ml-1 transition-transform group-hover:translate-x-1" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex justify-center mt-4 md:mt-8 gap-2">
                {testimonials.map((_, idx) => (
                  <button key={idx} onClick={() => setCurrentTestimonialIndex(idx)} className={`h-2 rounded-full transition-all duration-300 ${idx === currentTestimonialIndex ? "w-8 bg-purple-700" : "w-2 bg-gray-300 hover:bg-gray-400"}`} aria-label={`Go to slide ${idx + 1}`} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
*/}
            {/* Testimonials */}
     {/* Testimonials */}
<section className="py-12 md:py-20 bg-white">
  <div className="max-w-7xl mx-auto px-4 md:px-6 sm:px-12 lg:px-24">
    <div className="text-center mb-10 md:mb-16">
      <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight">
        What clients say about us
      </h3>
      <div className="w-20 h-1 bg-purple-600 mx-auto mt-3 rounded-full"></div>
    </div>

    <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
      
      {/* 1. INCREASED SIDE ILLUSTRATION SIZE */}
      <div className="w-full lg:w-[40%] flex justify-center lg:justify-end mb-8 lg:mb-0">
        <img 
          src={testiSideImg} 
          alt="Happy Clients" 
          className="w-[280px] md:w-[450px] lg:w-full max-w-[520px] object-contain drop-shadow-lg" 
        />
      </div>

      <div className="w-full lg:w-[60%] relative">
        <div className="overflow-hidden">
          <div 
            className="flex transition-transform duration-700 ease-in-out" 
            style={{ transform: `translateX(-${currentTestimonialIndex * 100}%)` }}
          >
            {testimonials.map((item) => (
              <div key={item.id} className="w-full flex-shrink-0 px-2">
                {/* min-h-[480px] ensures both boxes remain the same height */}
                <div className="bg-white border border-gray-100 shadow-2xl rounded-2xl p-8 md:p-12 min-h-[480px] flex flex-col justify-center"
                 onMouseEnter={() => setIsPaused(true)}
  onMouseLeave={() => setIsPaused(false)}>
                  
                  <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
                    
                    {/* Text Column */}
                    <div className="md:col-span-7">
                      <Quote className="w-12 h-12 text-purple-600 opacity-20 mb-4" />
                      {/* Fixed min-height here absorbs differences in text length */}
                      <div className="min-h-[160px] md:min-h-[200px]">
                        <p className="text-[16px] md:text-[19px] text-slate-700 leading-relaxed italic mb-8">
                          "{item.text}"
                        </p>
                      </div>
                      <div>
                        <h4 className="font-bold text-slate-900 text-[20px] md:text-[24px]">{item.name}</h4>
                        <p className="font-medium text-purple-600 text-[14px] md:text-[16px] uppercase tracking-wide mt-1">{item.title}</p>
                      </div>
                    </div>

                    {/* 2. INCREASED CLIENT IMAGE SIZE */}
                    <div className="md:col-span-5 flex flex-col items-center justify-center pt-8 md:pt-0">
                      <div className="relative p-1 bg-gradient-to-br from-purple-500/20 to-blue-500/20 rounded-2xl mb-4">
                        <img 
                          src={item.image} 
                          alt={item.name} 
                          className="w-32 h-32 md:w-44 md:h-44 lg:w-48 lg:h-48 object-cover rounded-xl border-4 border-white shadow-md" 
                        />
                      </div>
                      <a 
                        href={item.link} 
                        className="inline-flex items-center text-blue-600 hover:text-blue-800 font-bold text-base md:text-lg group"
                      >
                        Meet {item.name.split(' ')[0]} 
                        <ArrowRight size={22} className="ml-1 transition-transform group-hover:translate-x-1" />
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Dots */}
        <div className="flex justify-center mt-8 md:mt-10 gap-2">
          {testimonials.map((_, idx) => (
            <button 
              key={idx} 
              onClick={() => setCurrentTestimonialIndex(idx)} 
              className={`h-2.5 rounded-full transition-all duration-300 ${idx === currentTestimonialIndex ? "w-10 bg-purple-700" : "w-2.5 bg-gray-300 hover:bg-gray-400"}`} 
              aria-label={`Go to slide ${idx + 1}`} 
            />
          ))}
        </div>
      </div>
    </div>
  </div>
</section>

<section className="py-20 bg-white">
  {/* Standardized container for equal margins */}
  <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
    
    {/* SUBSCRIBE BOX */}
     <div 
      className="relative rounded-xl overflow-hidden py-10 px-6 text-center shadow-sm border border-slate-100" 
      style={{ 
        backgroundImage: `url(${kidBg})`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center' 
      }}
    >
      <div className="absolute inset-0 bg-white/60 backdrop-blur-[1px] -z-10" />

      <h4 className="text-[20px] md:text-[24px] text-slate-900 font-medium mb-6">
        Subscribe to KnowledgeBytes
      </h4>

      <div className="max-w-lg mx-auto flex flex-col sm:flex-row gap-3">
        <div className="relative flex-grow">
          <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
          <input 
            type="email" 
            placeholder="Email Address"
            className="w-full pl-11 pr-4 py-3 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-red-600/20 transition-all text-[15px]"
          />
        </div>
        <button className="bg-red-600 text-white px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-red-700 transition-colors shadow-md text-[15px]">
          <Check size={18} />
          Subscribe
        </button>
      </div>
    </div>
  </div>
</section>

    
      <section className="py-6 md:py-16 relative overflow-hidden" style={{ backgroundImage: `url(${faqBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
          <div className="text-center mb-6 md:mb-10">
{/*<h3 className="font-syne text-[28px] md:text-[40px] font-medium text-gray-900 tracking-widest mb-3">
              Frequently Asked Questions
            </h3>
            
             <h3 className="text-[24px] md:text-[38px] text-slate-900 tracking-tight font-medium font-syne">
        Frequently Asked Questions
      </h3> */}
   {/*   <h2 className="font-syne text-2xl md:text-4xl font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Frequently Asked Questions</h2> */}
      
      <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Frequently Asked Questions</h2>

    {/*    <h2 className="font-syne text-2xl md:text-3xl font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Frequently Asked Questions</h2> */}
            {/* <div className="w-24 h-1 bg-red-600 mx-auto mb-4 rounded-full"></div>
           <p className="font-syne text-gray-600 font-medium max-w-2xl mx-auto text-[16px] md:text-[24px]">Select a topic below to find quick answers.</p> */}
            <p className="text-[14px] md:text-[18px] text-gray-600 mt-1 font-medium">Select a topic below to find quick answers.</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {faqTopics.map((topic, idx) => (
  <Link
    key={idx}
    to={`/faqs#${topic.id}`}
    className="group cursor-pointer bg-white/80 backdrop-blur-sm
      border border-slate-200 rounded-lg p-2 md:p-3 text-center
      transition-all duration-300
      hover:bg-[#434242] hover:border-[#342242] hover:shadow-md "
  >
    <span className="block text-[14px] md:text-[18px] font-medium text-slate-700
  group-hover:text-white truncate leading-tight transition-colors duration-300">
  {topic.label}
</span>
  </Link>
))}

          </div>

        </div>
      </section>

   
    </div>
  );
};

export default Home;